module.exports = __webpack_public_path__ + "./images/grey_thumb.2c294c.jpg";